import { createSelector } from 'reselect';
import { DEFAULT_SELECT  } from '../containers/ticketMgmtPortal/forms/ticketFormConfigs';

export const ticketCategoriesSelector = (state) => state.ticketMgmt.categories.entities;
export const ticketCategoriesLoadedSelector = (state) => state.ticketMgmt.categories.loaded;
export const activeCategorySelector = (state) => state.ticketMgmt?.categories.activeCategory;

export const workflowsByCategoryLoadedSelector = (state) => state.ticketMgmt.ticketTypes.loaded;
export const workflowsByCategorySelector = (state) => state.ticketMgmt.ticketTypes.entities;

export const ticketTypeSelectOptionsLoadedSelector = (state) => state.ticketMgmt.ticketTypes.options.optionsLoaded;
export const ticketFormOptionsSelector = (state) => state.ticketMgmt.ticketTypes.options;

export const workgroupsOptionsSelector = createSelector(
    ticketFormOptionsSelector,
    ({ workgroups }) =>
        workgroups
            .reduce((acc, workgroup) => ([...acc, { value: workgroup.queueId, label: workgroup.label }]), [{ label: DEFAULT_SELECT, value: DEFAULT_SELECT }])
            .sort((a, b) => a.label.localeCompare(b.label))
);

export const sortedWorkflowsByCategorySelector = createSelector(
    workflowsByCategorySelector,
    ( workflows ) => {
        if (workflows && workflows.length > 0) {
            return workflows.slice().sort((a, b) => a.status.localeCompare(b.status) || a.type.localeCompare(b.type));
        }
    }
);

